
export const authorityKeyTmp = 'audit_process_management';
export const functionCode = 'audit_process_management';
export const permissionRole = 'audit_designated_members';
export const imagesBaseUrl = (window.feConfig && window.feConfig.common.imagesBaseUrl) || 'https://images.yxt.com/';
